import AuthBackground from './AuthBackground';

export default AuthBackground;
